import { render, staticRenderFns } from "./no-results-message.vue?vue&type=template&id=748e47be&scoped=true&"
import script from "./no-results-message.vue?vue&type=script&lang=js&"
export * from "./no-results-message.vue?vue&type=script&lang=js&"
import style0 from "./no-results-message.vue?vue&type=style&index=0&id=748e47be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e47be",
  null
  
)

export default component.exports